module.exports = __webpack_public_path__ + "img/malaysia.2cb24e71.svg";